






















import Vue from 'vue';

import Field from '@/components/Bulma/Field.vue';
import TInput from '@/components/Bulma/TInput.vue';
import HorizontalField from '@/components/Bulma/HorizontalField.vue';
import { AxiosError, AxiosResponse } from 'axios';
import OrderAPI from '@/services/OrderAPI';

import utilMixin from '@/mixin/Util';
import Util from '@/util/Util';

export default Vue.extend({
    name: 'CouponSelector',

    components: {
        Field,
        TInput,
        HorizontalField
    },

    mixins: [utilMixin],

    props: {
        value: String,
        orderId: String,
        readonly: Boolean
    },

    data() {
        return {
            couponCode: '',
            error: {
                save: ''
                },
            status: '',
            isSetLoading: false,
            isRemoveLoading: false
        };
    },

    created() {
		if (this.value) {
            this.couponCode = this.value;
        }
    },

    methods: {
        setCoupon(): void {
            this.error.save = '';

            const handleResponse = (response: AxiosResponse) => {
                    if (response.data) {
                        this.$store.commit('setOrder', response.data);
                    }
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error.save = error.response.data.message;
                    }
                };

            this.isSetLoading = true;

            if (Util.isEmpty(this.couponCode)) {
                OrderAPI
                    .deleteCouponCode(this.orderId)
                    .then(handleResponse)
                    .catch(handleError)
                    .finally(() => this.isSetLoading = false);
            } else {
                OrderAPI
                    .setCouponCode(this.orderId, this.couponCode)
                    .then(handleResponse)
                    .catch(handleError)
                    .finally(() => this.isSetLoading = false);
            }
        },

        removeCoupon(): void {
            this.error.save = '';

            const handleResponse = (response: AxiosResponse) => {
                    this.couponCode = '';
                    if (response.data) {
                        this.$store.commit('setOrder', response.data);
                    }
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error.save = error.response.data.message;
                    }
                };

            this.isRemoveLoading = true;

            OrderAPI
                .deleteCouponCode(this.orderId)
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isRemoveLoading = false);
        }
    }
});
